import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-disabled-feature-upsell',
  templateUrl: './disabled-feature-upsell.component.html',
  styleUrls: ['./disabled-feature-upsell.component.scss'],
})
export class DisabledFeatureUpsellComponent implements OnInit {
  @Input() title = 'Feature disabled';
  @Input() description = 'This feature is currently disabled.';
  @Input() badgeText = 'Disabled';

  @Input() renderMode: 'pill' | 'expanded' = 'pill';

  @Input() learnMoreLabel = 'Learn more';
  @Input() learnMoreHref: string | null = null;

  @Input() pillPosition: 'left' | 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'inline' = 'top-right';
  @Input() pillMode: 'absolute' | 'relative' = 'absolute';

  @Input() startOpen = false;

  isOpen = false;

  ngOnInit(): void {
    if (this.renderMode === 'expanded' || this.startOpen) {
      this.isOpen = true;
    }
  }

  toggleOpen(): void {
    if (this.renderMode === 'expanded') {
      return;
    }

    this.isOpen = !this.isOpen;
  }

  close(): void {
    if (this.renderMode === 'expanded') {
      return;
    }

    this.isOpen = false;
  }
}
